export default __webpack_public_path__ + "static/media/ic_export_black.8c5fd942.svg";